module.exports = __webpack_public_path__ + "static/img/2.志工服務活動2025.7618ed0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/2.志工服務活動2025.jpg
// module id = uDsI
// module chunks = 98